import React, { useState } from "react";
import styled from "@emotion/styled";
import Image from "next/image";
import YouTube, { YouTubeProps } from "react-youtube";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { useTranslations } from "next-intl";
import { Box, Grid, Typography } from "@mui/material";

function InfoVideoSection() {
  const opts: YouTubeProps["opts"] = {
    width: "100%",
    height: "450px",
    frameBorder: 2,
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      control: 0,
    },
  };
  const translation = useTranslations("collection.remaxCollection");

  const [hiddenIframe, IsHiddenFrame] = useState(true);
  return (
    <Grid
      container
      flexDirection={"column"}
      display="flex"
      justifyContent="center"
      rowGap={2}
      alignItems="center"
      px={2}
    >
      <Grid item xs={12} md={7} mb={4} maxWidth={450}>
        <Typography color="white" textAlign="center">
          {translation("description")}
        </Typography>
        <Typography color="white" textAlign="center">
          {translation("team")}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={5}
        sx={{
          width: {
            xs: "100%",
            md: "50%",
          },
          height: {
            xs: "300px",
          },
        }}
      >
        <YouTube
          videoId="Ta1P6nRn03Y"
          opts={opts}
          onEnd={() => {
            IsHiddenFrame(true);
          }}
        />
      </Grid>
    </Grid>
  );
}

export default InfoVideoSection;
